/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function($){
  var current = $('.Select--primary select option:selected').attr('data-option-1');

  $(".Select--primary select option").each(function(evt){
    if(current == $(this).attr('data-option-1') && $(this).attr('disabled') == "disabled"){
  	
      $('.HorizontalList__Item [data-value="'+$(this).attr('data-option-2')+'"]').attr("disabled","disabled");
    }
  });
  
});

  document.addEventListener('variant:changed', function(event) {
    var current = event.detail.variant.option1; // Gives you access to the whole variant details
    
    $(".Select--primary select option").each(function(evt){
    if(current == $(this).attr('data-option-1')){
      if($(this).attr('disabled') == "disabled"){
      $('.HorizontalList__Item [data-value="'+$(this).attr('data-option-2')+'"]').attr("disabled","disabled");
      } else {
      $('.HorizontalList__Item [data-value="'+$(this).attr('data-option-2')+'"]').removeAttr("disabled");
      }
    }
  });
  });